'use strict';
angular.module('components', ['components.abonnements', 'components.autorisations', 'components.echanges']);
angular.module('components.abonnements', []);
angular.module('components.autorisations', []);
angular.module('components.echanges', ['mgcrea.ngStrap.aside']);
